import { useContext } from 'react';
import { GlobalContext } from '../context';
import defaultLocale from '../locale';
function useTranslation(locale = null) {
  const {
    lang
  } = useContext(GlobalContext);
  const t = (locale || defaultLocale)[lang] || {};
  return key => {
    return t[key] ?? key;
  };
}
export default useTranslation;